import './index.scss';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLayoutEffect, useState, useRef } from 'react'
import { useTheme } from '../ThemeProvider'
import { useMemo } from 'react'
import { useMediaQuery } from 'react-responsive'

gsap.registerPlugin(ScrollTrigger);


const frontend = [
  {
    name: 'Frameworks',
    icon: 'triangle',
    array: [
      'Vue',
      'Nuxt.js',
      'React',
      'Next.js',
      'React-Native',
      'Flutter'
    ]
  },
  {
    name: 'Tools',
    icon: 'bag',
    array: [
      'TypeScript',
      'Webpack',
      'Vite',
      'Gulp',
      'pnpm'
    ]
  },  {
    name: 'Others',
    icon: 'smile',
    array: [
      'Three.js',
      'D3.js',
      'GSAP',
      'Enzyme',
      '...'
    ]
  }
]

const fullstack = [
  {
    name: 'Languages',
    icon: 'code',
    array: [
      'Node.js/JS',
      'Python',
      'Go',
      'Dart'
    ]
  },
  {
    name: 'Frameworks',
    icon: 'database',
    array: [
      'Express',
      'Koa2',
      'Flask',
      'Gin'
    ]
  },  {
    name: 'Others',
    icon: 'smile-reverse',
    array: [
      'Jest',
      'MongoDB',
      'Redis',
      'Kafka',
      'Elasticsearch',
      'Docker/K8s',
      '...'
    ]
  }
]
function Skill() {

  const [activeIdx, setActiveIdx] = useState(0)
  const container = useRef(null);
  const { theme } = useTheme();
  const isDarkMode = useMemo(() => theme==='dark', [theme])
  const iconMode = useMemo(() => isDarkMode?'fill':'outline', [isDarkMode])
  const isMobile = useMediaQuery({ maxWidth: 767 })
  const [frontendProgrss, setFrontendProgrss] = useState(0.5) // 0-0.5
  const [fullstackProgrss, setFullstackProgrss] = useState(0) // 0-0.5


  const renderPanel = ( array, progrss ) =>(
  <div className='panel' style={{opacity: progrss*1.6 + 0.2}}>
    {
      array.map(({name, icon ,array})=>(
        <div key={name} className='item'>
          <i className={`iconfont icon-${icon}-${iconMode}`}></i>
          <p>{name}</p>
          <ul>
            {array.map(item=>(<li key={item}>{item}</li>))}
          </ul>
        </div>
      ))
    }
  </div>)

  useLayoutEffect(() => {
    let mm = gsap.matchMedia(container);
    mm.add("(max-width: 767px)", () => {
      let sections = gsap.utils.toArray(".panel");
      gsap.to(sections, {
        xPercent: -100 * (sections.length - 1),
        ease: "none", // <-- IMPORTANT!
        scrollTrigger: {
          trigger: ".skill",
          scrub: 0.6,
          pin: true,
          start: "top top",
        }
      });
      const Totalwidth = gsap.getProperty('.position', 'offsetWidth','px').replace('px','');
      const Frontwidth = gsap.getProperty('.frontend', 'offsetWidth', 'px').replace('px','');
      const FullWidth = gsap.getProperty('.fullstack', 'offsetWidth', 'px').replace('px','');
      const x = (Totalwidth-Frontwidth)/2;
      const xEnd = (Totalwidth-FullWidth)/2-Frontwidth;
      gsap.fromTo('.position',{x:`${x}px`}, {
        scrollTrigger: {
          trigger: ".skill",
          scrub: 0.1,
          start: "center center",
          onUpdate: ({progress}) => {
              if (progress >= 0.5) {
                setActiveIdx(1)
                setFrontendProgrss(0)
                setFullstackProgrss(progress-0.5)
              } else {
                setActiveIdx(0)
                setFullstackProgrss(0)
                setFrontendProgrss(0.5-progress)
              }
              
          }
        },
        x:`${xEnd}px`,
      })
    })
    mm.add("(min-width: 768px)", (ctx) => {
      let sections = gsap.utils.toArray(".panel");
      gsap.to(sections, {
        xPercent: -100 * (sections.length - 1),
        ease: "none", // <-- IMPORTANT!
        scrollTrigger: {
          trigger: ".skill",
          scrub: 0.6,
          pin: true,
          start: "center center",
        }
      });
      const Totalwidth = gsap.getProperty('.position', 'offsetWidth','px').replace('px','');
      const Frontwidth = gsap.getProperty('.frontend', 'offsetWidth', 'px').replace('px','');
      const FullWidth = gsap.getProperty('.fullstack', 'offsetWidth', 'px').replace('px','');
      const x = (Totalwidth-Frontwidth)/2;
      const xEnd = (Totalwidth-FullWidth)/2-Frontwidth;
      gsap.fromTo('.position',{x:`${x}px`}, {
        scrollTrigger: {
          trigger: ".skill",
          scrub: 0.1,
          start: "center center",
          onUpdate: ({progress}) => {
              if (progress >= 0.5) {
                setActiveIdx(1)
                setFrontendProgrss(0)
                setFullstackProgrss(progress-0.5)
              } else {
                setActiveIdx(0)
                setFullstackProgrss(0)
                setFrontendProgrss(0.5-progress)
              }
              
          }
        },
        x:`${xEnd}px`,
      })
    })
    return () => mm.revert();
  }, []);

  return (
    <div ref={container}>
      <div className='section skill space' id='skill'>
        <p className='title' id='pin'>Skill</p>
        <p className='desc'>I work as a ....</p>
        <p className='position'><span className={`${activeIdx%2?'':'active'} frontend`} style={{opacity: 1.6* frontendProgrss + 0.2}}>Frontend {isMobile?'':'Developer'}</span><span className={`${activeIdx%2?'active':''} fullstack`} style={{opacity: 1.6*fullstackProgrss + 0.2}}>Fullstack {isMobile?'':'Developer'}</span></p>
        <div className='panel_wrapper'>
          {renderPanel(frontend, frontendProgrss)}
          {renderPanel(fullstack, fullstackProgrss)}
        </div>
      </div>
    </div>
  );
}
export default Skill;